<template>
  <div>
    <div class="members-page">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "SimpleLayout",
  computed: {
    simplePageClasses() {
      let simplePageClasses = [
        "members"
      ].includes(this.$route.name);
      return simplePageClasses;
    },
  }
};
</script>
